export default "__VITE_ASSET__D$scWQO___"